import { AxiosRequestConfig } from "axios";

export const getApplicationNameConfig = (ApplicationId: string): AxiosRequestConfig => {
  return {
    method: "get",
    url: `/application/${ApplicationId}/form-name`,
  };
};
